/**
 * @generated SignedSource<<63bacc9a4ee0f1bd66220c66d84e3887>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FileElementForm_FileElementV2Fragment$data = {
  readonly file: {
    readonly id: string;
  } | null | undefined;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "FileElementForm_FileElementV2Fragment";
};
export type FileElementForm_FileElementV2Fragment$key = {
  readonly " $data"?: FileElementForm_FileElementV2Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FileElementForm_FileElementV2Fragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FileElementForm_FileElementV2Fragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "FileElementV2",
  "abstractKey": null
};
})();

(node as any).hash = "602274a591a72fcd354aead4939d455a";

export default node;
